export default {
  methods: {
    fireMetaTrackerEvent(eventName, params = {}) {
      fbq('trackCustom', eventName, params);
    },
  },
};
